"use client";

import { PROCESSES } from "@/constants/process";
import { useImpressionTracking } from "@/hooks/useImpressionTracking";

import Process from "./Process";

function ProcessSection() {
  const sectionRef = useImpressionTracking<HTMLElement>(
    {
      eventName: "process_section_view",
      params: { section: "service_process" },
    },
    0.5,
  );

  return (
    <section ref={sectionRef} className="w-full py-12">
      <div className="flex flex-col gap-8">
        {/* Section Header */}
        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-24 font-semibold text-slate-900 tablet:text-28">서비스 프로세스</h2>
          <p className="text-16 font-light text-slate-600 tablet:text-18">
            문의부터 리스트 전달까지, 빠르고 체계적으로 진행됩니다
          </p>
        </div>

        {/* Timeline Container - Horizontal on desktop, vertical on mobile */}
        <div className="relative">
          {/* Desktop Timeline Line */}
          <div className="absolute left-0 right-0 top-8 hidden h-[2px] bg-gradient-to-r from-transparent via-slate-200 to-transparent desktop:block" />

          {/* Mobile Timeline Line */}
          <div className="absolute left-6 top-0 bottom-0 w-[2px] bg-gradient-to-b from-transparent via-slate-200 to-transparent desktop:hidden" />

          {/* Process Cards Grid */}
          <div className="relative grid grid-cols-1 gap-6 pl-6 desktop:grid-cols-6 desktop:gap-4 desktop:pl-0">
            {PROCESSES.map((process, index) => (
              <Process key={process.title} process={process} index={index} isLast={index === PROCESSES.length - 1} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProcessSection;
